import {
  API_CREATED,
  API_CREATE_FAILED,
  API_READ,
  API_READ_FAILED,
  API_UPDATED,
  API_UPDATE_FAILED,
  API_DELETED,
  API_DELETE_FAILED,
} from '@keypr/redux-json-api/lib/constants';
import { t } from '../../i18n';

import {
  API_AUTHORIZED,
  API_UNAUTHORIZED,
  LOCALE_FETCH_FAILED,
} from '../types';
import actions from '../actions';

const apiErrorMiddleware = store => next => (action) => {
  const {
    auth: {
      unauthorized,
    },
  } = store.getState();
  if (unauthorized === true && [API_CREATED, API_READ, API_UPDATED, API_DELETED].indexOf(action.type) !== -1) {
    store.dispatch({
      type: API_AUTHORIZED,
      payload: action.payload,
    });
  }

  if ([API_CREATE_FAILED, API_READ_FAILED, API_UPDATE_FAILED, API_DELETE_FAILED, LOCALE_FETCH_FAILED].indexOf(action.type) !== -1) {
    const messages = {
      API_CREATE_FAILED: t('Failed to create. Please try again!'),
      API_READ_FAILED: t('Failed to load. Please try again!'),
      API_UPDATE_FAILED: t('Failed to update. Please try again!'),
      API_DELETE_FAILED: t('Failed to delete. Please try again!'),
      LOCALE_FETCH_FAILED: t('Failed to load translation. Please try again!'),
    };

    if (action.payload.response && action.payload.response.status && action.payload.response.status === 401) {
      store.dispatch({
        type: API_UNAUTHORIZED,
        payload: action.payload,
      });
    }
    store.dispatch(actions.showNotification(messages[action.type], true, {
      type: 'danger',
      location: 'bottom-center',
      showClose: true,
    }));
  }
  return next(action);
};

export default apiErrorMiddleware;



// WEBPACK FOOTER //
// ./src/state/middleware/apiError.js